module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_8023.13dc9fe4.png";